import React from 'react';

const WizardHeader = ({ title, progress = 0, leftText, rightText, onClose, className = '' }) => {
  return (
    <div className={`absolute top-0 left-0 right-0 z-10 bg-white/95 backdrop-blur-sm border-b border-succession-border ${className}`}>
      <div className="flex items-center justify-between p-6">
        <div className="flex items-center gap-3 text-xs md:text-sm text-succession-muted">
          <button type="button" aria-label="Close" onClick={onClose} className="text-succession-primary hover:underline">×</button>
          <span>{leftText}</span>
        </div>
        <div className="text-sm font-medium text-succession-foreground">{title}</div>
        <div className="text-xs md:text-sm text-succession-muted">{rightText}</div>
      </div>
      <div className="h-1 bg-succession-bg-tertiary">
        <div className="h-full bg-succession-primary transition-all duration-300 ease-out" style={{ width: `${Math.max(0, Math.min(100, progress))}%` }} />
      </div>
    </div>
  );
};

export default WizardHeader;


